import React, { Component } from 'react';
import { connect } from 'react-redux';
import TenantSources from '../../sources/tenant';
import { TENANT_VIEWS } from './tenantPages';
import { bindMethods } from '../../utils/core';
import { addNotification } from '../../actions/reduxActions/notification';

export class CreateSubtenant extends Component {

    state = {
        subtenantName: '',
    };

    constructor(props) {
        super(props);

        bindMethods(
            this,
            'onChange',
            'onCreate',
        );
    }

    onChange({ target }) {
        this.setState({
            subtenantName: target.value,
        });
    }

    onCreate() {

        const { authenticationToken, navigateTo } = this.props;

        TenantSources.createSubtenant(authenticationToken, this.props.tenantId, this.state.subtenantName)
            .then(
                () => navigateTo(TENANT_VIEWS.tenant),
                error => this.props.addNotification({
                    type: 'error',
                    message: error.message,
                    isPersistent: true,
                }),
            );
    }

    render() {

        const { navigateTo } = this.props;

        return (
            <React.Fragment>
                <div className="admin-page">
                    <div className="form-group">
                        <label>
                            The name for the Subtenant
                            <span className="input-required"> *</span>
                        </label>
                        <input maxLength="255" required className="form-control admin-input" type="text" onInput={this.onChange} />
                        <span className="help-block">
                            This will create a new Subtenant with the following naming convention:
                            @&lt;subtenantname&gt;+&lt;maintenant&gt;.manywho.com.
                            You can login to the Subtenant using your current password.
                        </span>
                    </div>
                </div>

                <div className="mw-footer container-fluid">

                    <button
                        type="button"
                        className="outcome btn btn-default create-subtenant-cancel"
                        onClick={() => navigateTo(TENANT_VIEWS.tenant)}
                    >
                        Back
                    </button>

                    <button
                        type="button"
                        className="btn btn-primary outcome create-subtenant"
                        onClick={this.onCreate}
                    >
                        Create
                    </button>
                </div>
            </React.Fragment>
        );
    }
}

const mapDispatchToProps = {
    addNotification,
};

export default connect(
    null,
    mapDispatchToProps,
)(CreateSubtenant);
